const stationsModulePath = '/stations/:stationRecordNumber'

export const routes = {
  home: {
    path: '/',
  },
  stationSearch: {
    path: '/stations/',
  },
  stationsModule: {
    path: stationsModulePath,
  },
  stationPageTab: {
    path: `${stationsModulePath}/:stationTabValue`,
  },
  newSpeci: {
    path: `${stationsModulePath}/speci/new/:speciId`,
  },
  editSpeci: {
    path: `${stationsModulePath}/speci/edit/:speciId`,
  },
  viewSpeci: {
    path: `${stationsModulePath}/speci/view/:speciId`,
  },
  woolDataTab: {
    path: `${stationsModulePath}/:stationTabValue/:woolDataTabValue`,
  },
  offers: {
    path: '/offers/',
  },
  offersTab: {
    path: `/offers/:offersTabValue`,
  },
  newOffer: {
    path: `/offers/new`,
  },
  viewOffer: {
    path: `/offers/view/:offerId`,
  },
  typingProgram: {
    path: '/typing/program',
  },
  typedLots: {
    path: '/typing/typed-lots',
  },
  woolStoreTools: {
    path: '/wool-store-tools',
  },
  admin: {
    path: '/admin',
  },
}
